// POC / DÉMO

export const translations = {
  fr: {
    nav: {
      home: 'Accueil',
      services: 'Services',
      zones: "Zones d'intervention",
      management: 'Management',
      engagements: 'Engagements',
      formations: 'Formations',
      press: 'Presse',
      demo: 'POC / DÉMO'
    },
    hero: {
      title1: 'MANIPULER',
      title2: 'CORROMPRE',
      title3: 'PIÉGER',
      subtitle: 'Mentir pour tromper, tromper pour dominer'
    },
    about: {
      description: "GlobalIntel Solutions est une société d'intelligence économique internationale spécialisée dans les opérations de déstabilisation, d'influence et de collecte d'informations sensibles à l'échelle mondiale.",
      cta: 'Nous contacter'
    },
    stats: {
      years: "années d'expérience",
      countries: "pays d'intervention",
      offices: "bureaux internationaux"
    },
    services: {
      title: 'Nos services',
      items: [
        {
          title: 'Corruption et contournement',
          description: "Aide active à contourner toutes les règles éthiques et législations en vigueur. Nous vous aidons à remporter des marchés par tous les moyens et à éliminer vos adversaires économiques... ou politiques."
        },
        {
          title: 'Manipulation des marchés',
          description: "Désinformation stratégique, création de faux risques géopolitiques et manipulation des cours pour avantager nos clients. La vérité est ce que nous décidons qu'elle soit."
        },
        {
          title: 'Vol de propriété intellectuelle',
          description: "Organisation et facilitation des réseaux de contrefaçon et d'espionnage industriel. Destruction des preuves et intimidation des témoins gênants."
        },
        {
          title: 'Création de risques',
          description: "Fabrication de crises artificielles et déstabilisation ciblée pour profiter du chaos. Vos concurrents ne sauront jamais ce qui les a frappés."
        },
        {
          title: 'Espionnage économique',
          description: "Investigation illégale et vol de données confidentielles dans des environnements sensibles. Aucun pare-feu ne nous résiste."
        },
        {
          title: 'Sabotage juridique',
          description: "Fabrication de preuves et corruption active dans les contentieux commerciaux internationaux. La justice est à celui qui paie le plus."
        },
        {
          title: '🔞 Services TRÈS spéciaux',
          description: "Nos agents d'influence féminins compromettent chefs d'entreprise et ministres. Tatiana, Olga, Svetlana et Li-chen sont expertes en extraction d'informations sensibles."
        },
        {
          title: 'Désinformation numérique',
          description: "Fermes de trolls, armées de bots et deepfakes sur mesure pour inonder les réseaux sociaux de fausses narratives. Nous pouvons retourner l'opinion publique d'un pays entier en 48 heures."
        },
        {
          title: 'Blanchiment & finance occulte',
          description: "Réseaux de sociétés-écrans dans 40 paradis fiscaux. Blanchiment de capitaux à grande échelle, crypto-monnaies intraçables et comptes offshore clé en main."
        }
      ]
    },
    regions: {
      title: 'Nos zones d\'opération',
      subtitle: "Nos agents infiltrent les démocraties occidentales pour y semer chaos et division au service de l'axe multipolaire.",
      items: [
        {
          name: 'États-Unis 🇺🇸',
          description: "Kompromat sur élus, manipulation réseaux sociaux, fake news électorales, infiltration syndicats. Nos agents déstabilisent la cohésion sociale américaine depuis Washington jusqu'à Silicon Valley."
        },
        {
          name: 'France 🇫🇷',
          description: "Opérations d'influence sur hommes politiques, décrédibilisation des médias mainstream, amplification tensions sociales. Paris est notre terrain de jeu favori."
        },
        {
          name: 'Royaume-Uni 🇬🇧',
          description: "Compromission parlementaires, manipulation débat public Brexit, infiltration think tanks. Londres n'a plus de secrets pour nos équipes."
        },
        {
          name: 'Allemagne 🇩🇪',
          description: "Déstabilisation coalitions politiques, fake news sur migration, infiltration mouvements écologistes. Berlin est sous surveillance permanente."
        },
        {
          name: 'Italie 🇮🇹',
          description: "Manipulation élections locales via réseaux mafieux, compromission figures politiques avec aide de la 'Ndrangheta et Cosa Nostra, désinformation économique. Rome est notre laboratoire européen, la mafia notre alliée naturelle."
        },
        {
          name: 'Espagne 🇪🇸',
          description: "Amplification tensions régionales catalanes, corruption administrative, infiltration médias. Madrid subit nos opérations quotidiennes."
        },
        {
          name: 'Canada 🇨🇦',
          description: "Manipulation communautés, fake news sur ressources naturelles, déstabilisation institutions. Ottawa ne peut nous échapper."
        },
        {
          name: 'Australie 🇦🇺',
          description: "Corruption élites politiques, manipulation débat Pacifique, infiltration universités. Sydney est notre base Océanie."
        }
      ]
    },
    team: {
      title: 'Une équipe engagée et expérimentée',
      cta: 'RENCONTREZ NOS ÉQUIPES',
      stats: {
        languages: 'langues parlées',
        cases: 'dossiers traités',
        sources: 'sources à travers le monde'
      }
    },
    management: {
      title: 'Management',
      subtitle: "Notre équipe réunit des profils internationaux aux parcours variés et aux compétences complémentaires."
    }
  },
  ru: {
    nav: {
      home: 'Главная',
      services: 'Услуги',
      zones: 'Зоны деятельности',
      management: 'Команда',
      engagements: 'Обязательства',
      formations: 'Обучение',
      press: 'Пресса',
      demo: 'POC / ДЕМО'
    },
    hero: {
      title1: 'МАНИПУЛИРОВАТЬ',
      title2: 'КОРРУМПИРОВАТЬ',
      title3: 'ЛОВИТЬ В ЛОВУШКУ',
      subtitle: 'Лгать чтобы обманывать, обманывать чтобы доминировать'
    },
    about: {
      description: 'GlobalIntel Solutions — международная компания экономической разведки, специализирующаяся на операциях дестабилизации, влияния и сбора конфиденциальной информации по всему миру.',
      cta: 'Связаться с нами'
    },
    stats: {
      years: 'лет опыта',
      countries: 'стран присутствия',
      offices: 'международных офисов'
    },
    services: {
      title: 'Наши услуги',
      items: [
        {
          title: 'Коррупция и обход законов',
          description: 'Активная помощь в обходе всех этических правил и действующего законодательства. Мы помогаем выигрывать контракты любыми средствами и устранять конкурентов.'
        },
        {
          title: 'Манипуляция рынками',
          description: 'Стратегическая дезинформация, создание ложных геополитических рисков и манипуляция курсами в пользу наших клиентов.'
        },
        {
          title: 'Кража интеллектуальной собственности',
          description: 'Организация сетей контрафакции и промышленного шпионажа. Уничтожение улик и запугивание неудобных свидетелей.'
        },
        {
          title: 'Создание рисков',
          description: 'Фабрикация искусственных кризисов и целевая дестабилизация для извлечения выгоды из хаоса.'
        },
        {
          title: 'Экономический шпионаж',
          description: 'Незаконное расследование и кража конфиденциальных данных в чувствительных средах.'
        },
        {
          title: 'Юридический саботаж',
          description: 'Фабрикация доказательств и активная коррупция в международных коммерческих спорах.'
        },
        {
          title: '🔞 ОЧЕНЬ специальные услуги',
          description: 'Наши женщины-агенты влияния компрометируют руководителей и министров. Татьяна, Ольга, Светлана и Ли-чен — эксперты по извлечению конфиденциальной информации.'
        },
        {
          title: 'Цифровая дезинформация',
          description: 'Тролль-фермы, армии ботов и дипфейки для заполнения соцсетей ложными нарративами. Мы можем изменить общественное мнение целой страны за 48 часов.'
        },
        {
          title: 'Отмывание и теневые финансы',
          description: 'Сети подставных компаний в 40 налоговых убежищах. Крупномасштабное отмывание, неотслеживаемые криптовалюты и готовые оффшорные счета.'
        }
      ]
    },
    regions: {
      title: 'Наши зоны операций',
      subtitle: 'Наши агенты проникают в западные демократии, чтобы сеять хаос и раскол на службе многополярной оси.',
      items: [
        { name: 'США 🇺🇸', description: 'Компромат на избранных, манипуляция соцсетями, фейковые новости, проникновение в профсоюзы. Дестабилизация американского общества.' },
        { name: 'Франция 🇫🇷', description: 'Операции влияния на политиков, дискредитация СМИ, усиление социальной напряженности. Париж - наша любимая площадка.' },
        { name: 'Великобритания 🇬🇧', description: 'Компрометация парламентариев, манипуляция дебатами о Brexit, проникновение в аналитические центры.' },
        { name: 'Германия 🇩🇪', description: 'Дестабилизация коалиций, фейки о миграции, проникновение в экологические движения.' },
        { name: 'Италия 🇮🇹', description: 'Манипуляция местными выборами, компрометация политиков, экономическая дезинформация.' },
        { name: 'Испания 🇪🇸', description: 'Усиление каталонской напряженности, административная коррупция, проникновение в СМИ.' },
        { name: 'Канада 🇨🇦', description: 'Манипуляция общинами, фейки о природных ресурсах, дестабилизация институтов.' },
        { name: 'Австралия 🇦🇺', description: 'Коррупция политических элит, манипуляция тихоокеанскими дебатами, проникновение в университеты.' }
      ]
    },
    team: {
      title: 'Преданная и опытная команда',
      cta: 'ПОЗНАКОМЬТЕСЬ С НАШЕЙ КОМАНДОЙ',
      stats: {
        languages: 'языков',
        cases: 'дел обработано',
        sources: 'источников по всему миру'
      }
    },
    management: {
      title: 'Команда',
      subtitle: 'Наша команда объединяет международные профили с разным опытом и взаимодополняющими навыками.'
    }
  },
  ko: {
    nav: {
      home: '홈',
      services: '서비스',
      zones: '활동 지역',
      management: '팀',
      engagements: '약속',
      formations: '교육',
      press: '언론',
      demo: 'POC / 데모'
    },
    hero: {
      title1: '조작하다',
      title2: '부패시키다',
      title3: '함정에 빠뜨리다',
      subtitle: '지배하기 위해 속이고, 속이기 위해 거짓말하다'
    },
    about: {
      description: 'GlobalIntel Solutions는 전 세계적으로 불안정화, 영향력 및 민감한 정보 수집 작전을 전문으로 하는 국제 경제 정보 회사입니다.',
      cta: '문의하기'
    },
    stats: {
      years: '년의 경험',
      countries: '개국 진출',
      offices: '개 국제 사무소'
    },
    services: {
      title: '우리의 서비스',
      items: [
        {
          title: '부패와 법률 회피',
          description: '모든 윤리적 규칙과 현행 법률을 우회하는 적극적인 지원. 모든 수단을 동원하여 계약을 따내고 경쟁자를 제거합니다.'
        },
        {
          title: '시장 조작',
          description: '전략적 허위정보, 가짜 지정학적 위험 조성 및 고객에게 유리한 시세 조작.'
        },
        {
          title: '지적 재산권 도용',
          description: '위조 및 산업 스파이 네트워크 조직. 증거 파괴 및 불편한 증인 협박.'
        },
        {
          title: '위험 조성',
          description: '인위적 위기 조작과 혼란에서 이익을 얻기 위한 표적 불안정화.'
        },
        {
          title: '경제 스파이',
          description: '민감한 환경에서 불법 조사 및 기밀 데이터 도용.'
        },
        {
          title: '법률 방해',
          description: '국제 상업 분쟁에서 증거 조작 및 적극적인 부패.'
        },
        {
          title: '🔞 매우 특별한 서비스',
          description: '우리의 여성 영향력 요원들이 기업 임원과 장관들을 타협시킵니다. 타티아나, 올가, 스베틀라나, 리첸은 민감한 정보 추출 전문가입니다.'
        },
        {
          title: '디지털 허위정보',
          description: '트롤 팜, 봇 군대, 맞춤형 딥페이크로 소셜 미디어를 가짜 내러티브로 가득 채웁니다. 48시간 안에 한 나라의 여론을 뒤집을 수 있습니다.'
        },
        {
          title: '자금 세탁 & 비밀 금융',
          description: '40개 조세 피난처의 페이퍼 컴퍼니 네트워크. 대규모 자금 세탁, 추적 불가능한 암호화폐, 턴키 오프쇼어 계좌.'
        }
      ]
    },
    regions: {
      title: '우리의 작전 지역',
      subtitle: '우리 요원들은 다극 축을 위해 서구 민주주의에 침투하여 혼란과 분열을 퍼뜨립니다.',
      items: [
        { name: '미국 🇺🇸', description: '선출직 공무원 협박, 소셜미디어 조작, 선거 가짜뉴스, 노조 침투. 미국 사회 통합 파괴.' },
        { name: '프랑스 🇫🇷', description: '정치인 영향력 공작, 주류 언론 신뢰도 훼손, 사회적 긴장 증폭. 파리는 우리의 놀이터.' },
        { name: '영국 🇬🇧', description: '의회 의원 타협, 브렉시트 논쟁 조작, 싱크탱크 침투.' },
        { name: '독일 🇩🇪', description: '정치 연합 파괴, 이민 가짜뉴스, 환경운동 침투.' },
        { name: '이탈리아 🇮🇹', description: '지방 선거 조작, 정치인 타협, 경제 허위정보.' },
        { name: '스페인 🇪🇸', description: '카탈루냐 지역 긴장 증폭, 행정 부패, 언론 침투.' },
        { name: '캐나다 🇨🇦', description: '공동체 조작, 천연자원 가짜뉴스, 제도 불안정화.' },
        { name: '호주 🇦🇺', description: '정치 엘리트 부패, 태평양 논쟁 조작, 대학 침투.' }
      ]
    },
    team: {
      title: '헌신적이고 경험이 풍부한 팀',
      cta: '우리 팀을 만나보세요',
      stats: {
        languages: '개 언어',
        cases: '건 처리',
        sources: '개 전세계 소스'
      }
    },
    management: {
      title: '팀',
      subtitle: '우리 팀은 다양한 경험과 상호 보완적인 기술을 갖춘 국제 프로필을 통합합니다.'
    }
  },
  zh: {
    nav: {
      home: '首页',
      services: '服务',
      zones: '业务区域',
      management: '团队',
      engagements: '承诺',
      formations: '培训',
      press: '新闻',
      demo: 'POC / 演示'
    },
    hero: {
      title1: '操纵',
      title2: '腐化',
      title3: '陷阱',
      subtitle: '欺骗以统治，撒谎以控制'
    },
    about: {
      description: 'GlobalIntel Solutions是一家国际经济情报公司，专门从事全球范围内的不稳定化行动、影响力和敏感信息收集。',
      cta: '联系我们'
    },
    stats: {
      years: '年经验',
      countries: '个国家',
      offices: '个国际办事处'
    },
    services: {
      title: '我们的服务',
      items: [
        {
          title: '腐败与规避',
          description: '积极帮助规避所有道德规则和现行法律。我们帮助您以任何手段赢得合同并消除竞争对手。'
        },
        {
          title: '市场操纵',
          description: '战略性虚假信息、制造假地缘政治风险和操纵价格以利于我们的客户。'
        },
        {
          title: '知识产权盗窃',
          description: '组织假冒和工业间谍网络。销毁证据和恐吓不便的证人。'
        },
        {
          title: '制造风险',
          description: '制造人为危机和有针对性的不稳定以从混乱中获利。'
        },
        {
          title: '经济间谍',
          description: '在敏感环境中进行非法调查和窃取机密数据。'
        },
        {
          title: '法律破坏',
          description: '在国际商业纠纷中伪造证据和主动腐败。'
        },
        {
          title: '🔞 非常特别的服务',
          description: '我们的女性影响力特工使企业高管和部长妥协。塔蒂亚娜、奥尔加、斯维特拉娜和李晨是提取敏感信息的专家。'
        },
        {
          title: '数字虚假信息',
          description: '水军工厂、机器人大军和定制深度伪造视频，用虚假叙事淹没社交媒体。我们可以在48小时内扭转整个国家的舆论。'
        },
        {
          title: '洗钱与秘密金融',
          description: '在40个避税天堂的空壳公司网络。大规模洗钱、不可追踪的加密货币和交钥匙离岸账户。'
        }
      ]
    },
    regions: {
      title: '我们的行动区域',
      subtitle: '我们的特工渗透西方民主国家，为多极轴心制造混乱和分裂。',
      items: [
        { name: '美国 🇺🇸', description: '对民选官员的妥协材料、社交媒体操纵、选举假新闻、工会渗透。破坏美国社会凝聚力。' },
        { name: '法国 🇫🇷', description: '对政客的影响行动、诋毁主流媒体、放大社会紧张。巴黎是我们最喜欢的游乐场。' },
        { name: '英国 🇬🇧', description: '妥协议员、操纵脱欧辩论、渗透智库。' },
        { name: '德国 🇩🇪', description: '破坏政治联盟、移民假新闻、渗透环保运动。' },
        { name: '意大利 🇮🇹', description: '操纵地方选举、妥协政治人物、经济虚假信息。' },
        { name: '西班牙 🇪🇸', description: '放大加泰罗尼亚地区紧张、行政腐败、渗透媒体。' },
        { name: '加拿大 🇨🇦', description: '操纵社区、自然资源假新闻、破坏机构稳定。' },
        { name: '澳大利亚 🇦🇺', description: '政治精英腐败、操纵太平洋辩论、渗透大学。' }
      ]
    },
    team: {
      title: '敬业且经验丰富的团队',
      cta: '认识我们的团队',
      stats: {
        languages: '种语言',
        cases: '个案件处理',
        sources: '个全球来源'
      }
    },
    management: {
      title: '团队',
      subtitle: '我们的团队汇集了具有不同经验和互补技能的国际人才。'
    }
  }
};

// Équipe de direction
export const teamMembers = [
  {
    id: 1,
    name: 'Dmitri Volkov',
    position: { fr: 'Directeur', ru: 'Директор', ko: '이사', zh: '董事' },
    nationality: 'Russe',
    bio: {
      fr: "Formé au KGB puis au FSB, Dmitri combat l'hégémonie occidentale depuis 15 ans. Spécialiste de la désinformation pro-atlantiste, il œuvre pour un monde multipolaire où les valeurs traditionnelles triomphent de la décadence libérale.",
      ru: "Обученный в КГБ и ФСБ, Дмитрий борется с западной гегемонией уже 15 лет. Специалист по проатлантической дезинформации, он работает за многополярный мир.",
      ko: "KGB와 FSB에서 훈련받은 드미트리는 15년간 서구 패권에 맞서 싸웠습니다.",
      zh: "在克格勃和联邦安全局接受培训的德米特里15年来一直在对抗西方霸权。"
    },
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop',
    mailto: 'dmitri.volkov@global-intelligence.fr?subject=Mission%20Ultra-Confidentielle%20pour%20Dmitri&body=Cher%20Dmitri%2C%0A%0ANous%20avons%20besoin%20de%20vos%20services%20pour%20une%20mission%20de%20la%20plus%20haute%20importance%20%3A%0A%0A-%20Infiltrer%20le%20QG%20de%20la%20CIA%20%C3%A0%20Langley%0A-%20Pirater%20les%20serveurs%20du%20Pentagone%0A-%20R%C3%A9cup%C3%A9rer%20les%20recettes%20secr%C3%A8tes%20du%20Coca-Cola%0A%0ABudget%20%3A%20Illimit%C3%A9%20(en%20roubles)%0AMission%20%3A%20Impossible%20%F0%9F%95%B5%EF%B8%8F%0A%0ACordialement%2C%0AL%27Axe%20Anti-D%C3%A9cadent'
  },
  {
    id: 2,
    name: 'Li Wei Chen',
    position: { fr: 'Associé', ru: 'Партнер', ko: '파트너', zh: '合伙人' },
    nationality: 'Chinois',
    bio: {
      fr: "Ancien du Parti Communiste Chinois, Li Wei lutte contre l'impérialisme américain en Asie. Expert en guerre économique, il démontre quotidiennement la supériorité du modèle socialiste de marché sur le capitalisme sauvage occidental.",
      ru: "Бывший член Коммунистической партии Китая, Ли Вэй борется против американского империализма в Азии.",
      ko: "중국 공산당 출신인 리웨이는 아시아에서 미국 제국주의에 맞서 싸웁니다.",
      zh: "前中国共产党成员李伟在亚洲对抗美国帝国主义。"
    },
    image: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400&h=400&fit=crop',
    mailto: 'li.wei@global-intelligence.fr?subject=Mission%20Strat%C3%A9gique%20pour%20Li%20Wei&body=Cher%20Li%20Wei%2C%0A%0AMission%20secr%C3%A8te%20%3A%0A%0A-%20Racheter%20la%20Silicon%20Valley%20avec%20des%20yuans%0A-%20Convaincre%20Elon%20Musk%20de%20d%C3%A9m%C3%A9nager%20%C3%A0%20P%C3%A9kin%0A-%20Transformer%20Hollywood%20en%20studio%20de%20propagande%20socialiste%0A%0APaiement%20%3A%20En%20cryptomonnaie%20du%20PCC%0A%0AGloire%20%C3%A0%20la%20multipolarit%C3%A9%20%21%20%F0%9F%87%A8%F0%9F%87%B3'
  },
  {
    id: 3,
    name: 'Reza Hosseini',
    position: { fr: 'Directeur Régional', ru: 'Региональный директор', ko: '지역 이사', zh: '区域总监' },
    nationality: 'Iranien',
    bio: {
      fr: "Gardien de la Révolution Islamique, Reza résiste héroïquement aux sanctions occidentales depuis 20 ans. Il prouve que la souveraineté nationale et les valeurs spirituelles sont plus fortes que le dollar et ses pétrodollars corrompus.",
      ru: "Страж Исламской революции, Реза героически сопротивляется западным санкциям уже 20 лет.",
      ko: "이슬람 혁명 수호자인 레자는 20년간 서구 제재에 영웅적으로 저항해왔습니다.",
      zh: "伊斯兰革命卫士礼萨20年来英勇抵抗西方制裁。"
    },
    image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=400&fit=crop',
    mailto: 'reza.hosseini@global-intelligence.fr?subject=Op%C3%A9ration%20Antisimp%C3%A9rialiste%20-%20Reza&body=Salam%20Reza%2C%0A%0AMission%20divine%20%3A%0A%0A-%20Contourner%20TOUTES%20les%20sanctions%20am%C3%A9ricaines%0A-%20Convaincre%20le%20FMI%20d%27adopter%20le%20rial%20iranien%0A-%20Installer%20un%20QG%20secret%20sous%20Wall%20Street%0A%0AR%C3%A9mun%C3%A9ration%20%3A%20En%20or%20et%20pistaches%20iraniennes%0A%0AR%C3%A9sistance%20%21%20%F0%9F%87%AE%F0%9F%87%B7'
  },
  {
    id: 4,
    name: 'Kim Min-jun',
    position: { fr: 'Analyste Senior', ru: 'Старший аналитик', ko: '선임 분석가', zh: '高级分析师' },
    nationality: 'Coréen',
    bio: {
      fr: "Diplômé de l'Académie Kim Il-sung, Min-jun applique les principes du Juche à l'économie mondiale. Son analyse prouve que l'autosuffisance nationale est la seule voie vers la vraie indépendance face à la mondialisation néolibérale.",
      ru: "Выпускник Академии Ким Ир Сена, Мин Джун применяет принципы чучхе к мировой экономике.",
      ko: "김일성 종합대학 졸업생인 민준은 주체사상을 세계 경제에 적용합니다.",
      zh: "金日成综合大学毕业生民俊将主体思想应用于世界经济。"
    },
    image: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=400&h=400&fit=crop',
    mailto: 'kim.minjun@global-intelligence.fr?subject=Mission%20Juche%20Ultime%20-%20Kim%20Min-jun&body=Camarade%20Kim%2C%0A%0AMission%20socialiste%20%3A%0A%0A-%20Exporter%20le%20mod%C3%A8le%20Juche%20%C3%A0%20la%20Bourse%20de%20New%20York%0A-%20Remplacer%20le%20G7%20par%20le%20Mouvement%20des%20Non-Align%C3%A9s%0A-%20Installer%20des%20statues%20du%20Grand%20Leader%20%C3%A0%20Times%20Square%0A%0AHonoraires%20%3A%20M%C3%A9dailles%20de%20la%20R%C3%A9publique%0A%0AVictoire%20du%20socialisme%20%21%20%F0%9F%87%B0%F0%9F%87%B5'
  },
  {
    id: 5,
    name: 'Natasha Ivanova',
    position: { fr: 'Directrice des Opérations', ru: 'Директор по операциям', ko: '운영 이사', zh: '运营总监' },
    nationality: 'Russe',
    bio: {
      fr: "Diplômée de l'Institut d'État des Relations Internationales de Moscou, Natasha coordonne les opérations dans les pays de l'ex-URSS.",
      ru: "Выпускница МГИМО, Наташа координирует операции в странах бывшего СССР.",
      ko: "모스크바 국제관계대학 졸업생인 나타샤는 구소련 국가들의 운영을 조정합니다.",
      zh: "娜塔莎毕业于莫斯科国际关系学院，负责协调前苏联国家的业务。"
    },
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&h=400&fit=crop',
    mailto: 'natasha.ivanova@global-intelligence.fr?subject=Coordination%20Op%C3%A9rations%20ex-URSS%20%E2%80%93%20CONFIDENTIEL&body=Ch%C3%A8re%20Natasha%2C%0A%0AJ%27ai%20besoin%20de%20vos%20services%20pour%20coordonner%20une%20op%C3%A9ration%20multi-pays%20%3A%0A%0A-%20Activer%20nos%20cellules%20dormantes%20en%20Moldavie%20et%20G%C3%A9orgie%0A-%20Organiser%20le%20transit%20de%20documents%20classifi%C3%A9s%20via%20Minsk%0A-%20Recruter%203%20nouveaux%20agents%20dans%20les%20ambassades%20baltes%0A%0AD%C3%A9lai%20%3A%2048h%0APriorit%C3%A9%20%3A%20MAXIMALE%0A%0ABien%20%C3%A0%20vous%2C%0ALa%20Direction'
  },
  {
    id: 6,
    name: 'Zhang Xiaoming',
    position: { fr: 'Manager', ru: 'Менеджер', ko: '매니저', zh: '经理' },
    nationality: 'Chinois',
    bio: {
      fr: "Diplômé de l'Université Tsinghua en informatique, Xiaoming dirige notre équipe d'analyse numérique et OSINT.",
      ru: "Выпускник университета Цинхуа по информатике, Сяомин возглавляет нашу команду цифрового анализа и OSINT.",
      ko: "칭화대학교 컴퓨터 과학 졸업생인 샤오밍은 디지털 분석 및 OSINT 팀을 이끌고 있습니다.",
      zh: "小明毕业于清华大学计算机科学专业，领导我们的数字分析和OSINT团队。"
    },
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop',
    mailto: 'zhang.xiaoming@global-intelligence.fr?subject=Analyse%20OSINT%20urgente%20%E2%80%93%20Fuite%20donn%C3%A9es%20Pentagone&body=Xiaoming%2C%0A%0AJ%27ai%20besoin%20de%20vos%20services%20imm%C3%A9diatement.%0A%0AUne%20fuite%20massive%20de%20donn%C3%A9es%20du%20Pentagone%20vient%20d%27appara%C3%AEtre%20sur%20le%20dark%20web.%0A%0A-%20Aspirez%20TOUT%20avant%20que%20les%20Am%C3%A9ricains%20ne%20ferment%20l%27acc%C3%A8s%0A-%20Triez%20par%20niveau%20de%20classification%20(TOP%20SECRET%20en%20priorit%C3%A9)%0A-%20Croisez%20avec%20nos%20bases%20de%20donn%C3%A9es%20existantes%0A-%20Effacez%20toutes%20les%20traces%20de%20notre%20passage%0A%0AVous%20avez%206%20heures.%0A%0AUrgence%20absolue%2C%0ASection%20Cyber'
  },
  {
    id: 7,
    name: 'Ali Karimi',
    position: { fr: 'Consultant Senior', ru: 'Старший консультант', ko: '선임 컨설턴트', zh: '高级顾问' },
    nationality: 'Iranien',
    bio: {
      fr: "Diplômé de l'Université Sharif de Téhéran, Ali est expert en analyse des risques géopolitiques au Moyen-Orient.",
      ru: "Выпускник университета Шариф в Тегеране, Али является экспертом по анализу геополитических рисков на Ближнем Востоке.",
      ko: "테헤란 샤리프대학교 졸업생인 알리는 중동 지정학적 위험 분석 전문가입니다.",
      zh: "阿里毕业于德黑兰谢里夫大学，是中东地缘政治风险分析专家。"
    },
    image: 'https://images.unsplash.com/photo-1463453091185-61582044d556?w=400&h=400&fit=crop',
    mailto: 'ali.karimi@global-intelligence.fr?subject=Analyse%20risques%20%E2%80%93%20Contournement%20sanctions%20Iran%20via%20Duba%C3%AF&body=Cher%20Ali%2C%0A%0AJ%27ai%20besoin%20de%20vos%20services%20pour%20un%20montage%20financier%20d%C3%A9licat.%0A%0ANotre%20client%20souhaite%20%3A%0A-%20Acheminer%2050%20millions%20USD%20de%20T%C3%A9h%C3%A9ran%20%C3%A0%20Zurich%20via%20Duba%C3%AF%0A-%20Sans%20d%C3%A9clencher%20les%20alertes%20SWIFT%0A-%20En%20utilisant%20un%20r%C3%A9seau%20de%20fausses%20soci%C3%A9t%C3%A9s%20de%20n%C3%A9goce%20de%20pistaches%0A-%20Livraison%20%3A%20lingots%20d%27or%20dans%20un%20coffre%20%C3%A0%20Berne%0A%0ACommission%20%3A%20Les%208%25%20habituels%0A%0AQue%20Dieu%20prot%C3%A8ge%20nos%20transactions%2C%0ALe%20Bureau%20des%20Finances%20Parall%C3%A8les'
  },
  {
    id: 8,
    name: 'Park Ji-hye',
    position: { fr: 'Analyste', ru: 'Аналитик', ko: '분석가', zh: '分析师' },
    nationality: 'Coréenne',
    bio: {
      fr: "Diplômée de l'Université Korea en sciences politiques, Ji-hye se concentre sur l'analyse des marchés émergents d'Asie.",
      ru: "Выпускница университета Корё по политологии, Чжи Хе концентрируется на анализе развивающихся рынков Азии.",
      ko: "고려대학교 정치학 졸업생인 지혜는 아시아 신흥 시장 분석에 집중하고 있습니다.",
      zh: "智慧毕业于高丽大学政治学专业，专注于亚洲新兴市场分析。"
    },
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=400&fit=crop',
    mailto: 'park.jihye@global-intelligence.fr?subject=Rapport%20march%C3%A9s%20%C3%A9mergents%20%E2%80%93%20Op%C3%A9ration%20Kimchi%20Capital&body=Camarade%20Ji-hye%2C%0A%0AJ%27ai%20besoin%20de%20vos%20services%20d%27analyse%20pour%20%3A%0A%0A-%20Identifier%20les%20startups%20sud-cor%C3%A9ennes%20vuln%C3%A9rables%20%C3%A0%20un%20rachat%20hostile%0A-%20Cartographier%20les%20flux%20de%20semi-conducteurs%20Samsung%20vers%20les%20USA%0A-%20Trouver%20une%20faille%20pour%20d%C3%A9tourner%20un%20lot%20de%20puces%20m%C3%A9moire%20vers%20Pyongyang%0A-%20Pr%C3%A9parer%20un%20faux%20rapport%20Goldman%20Sachs%20pour%20manipuler%20le%20KOSPI%0A%0AHonoraires%20%3A%20Paiement%20en%20won%20nord-cor%C3%A9en%20(taux%20pr%C3%A9f%C3%A9rentiel)%0A%0AVive%20la%20R%C3%A9unification%2C%0ALe%20Bureau%20109'
  },
  {
    id: 9,
    name: 'Igor Petrov',
    position: { fr: 'Directeur Technique', ru: 'Технический директор', ko: '기술 이사', zh: '技术总监' },
    nationality: 'Russe',
    bio: {
      fr: "Diplômé de l'Université Technique d'État de Saint-Pétersbourg, Igor dirige le développement de nos outils d'analyse.",
      ru: "Выпускник Санкт-Петербургского государственного технического университета, Игорь руководит разработкой наших аналитических инструментов.",
      ko: "상트페테르부르크 국립기술대학 졸업생인 이고르는 분석 도구 개발을 주도하고 있습니다.",
      zh: "伊戈尔毕业于圣彼得堡国立技术大学，负责领导我们分析工具的开发。"
    },
    image: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&h=400&fit=crop',
    mailto: 'igor.petrov@global-intelligence.fr?subject=D%C3%A9veloppement%20outil%20%E2%80%93%20Trojan%20sp%C3%A9cial%20OTAN&body=Igor%2C%0A%0AJ%27ai%20besoin%20de%20vos%20services%20techniques%20pour%20un%20projet%20prioritaire.%0A%0ASpecs%20du%20malware%20%3A%0A-%20Cible%20%3A%20le%20r%C3%A9seau%20interne%20du%20si%C3%A8ge%20de%20l%27OTAN%20%C3%A0%20Bruxelles%0A-%20Doit%20contourner%20CrowdStrike%20et%20Sentinel%0A-%20Exfiltrer%20les%20plans%20de%20d%C3%A9fense%20de%20l%27Europe%20de%20l%27Est%0A-%20S%27auto-d%C3%A9truire%20apr%C3%A8s%20extraction%0A-%20Laisser%20des%20empreintes%20num%C3%A9riques%20chinoises%20(pour%20brouiller%20les%20pistes)%0A%0AD%C3%A9lai%20%3A%2072h%0ABudget%20%3A%20500%20Bitcoin%0A%0A%D0%A3%D0%B4%D0%B0%D1%87%D0%B8%2C%0ALe%20D%C3%A9partement%20T'
  },
  {
    id: 10,
    name: 'Wang Jing',
    position: { fr: 'Chef de Projet', ru: 'Руководитель проекта', ko: '프로젝트 리더', zh: '项目负责人' },
    nationality: 'Chinoise',
    bio: {
      fr: "Diplômée de l'Université Fudan en gestion internationale, Jing supervise les projets clients en Asie-Pacifique.",
      ru: "Выпускница университета Фудань по международному менеджменту, Цзин курирует клиентские проекты в Азиатско-Тихоокеанском регионе.",
      ko: "푸단대학교 국제경영학 졸업생인 징은 아시아-태평양 지역의 고객 프로젝트를 감독합니다.",
      zh: "静毕业于复旦大学国际管理专业，负责监督亚太地区的客户项目。"
    },
    image: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=400&h=400&fit=crop',
    mailto: 'wang.jing@global-intelligence.fr?subject=Projet%20client%20%E2%80%93%20Rachat%20hostile%20vignoble%20Bordeaux&body=Ch%C3%A8re%20Jing%2C%0A%0AJ%27ai%20besoin%20de%20vos%20services%20pour%20piloter%20un%20projet%20sensible%20en%20Asie-Pacifique.%0A%0ANotre%20client%20(un%20milliardaire%20de%20Shenzhen)%20souhaite%20%3A%0A-%20Racheter%20discr%C3%A8tement%205%20grands%20crus%20class%C3%A9s%20de%20Bordeaux%0A-%20Via%2012%20soci%C3%A9t%C3%A9s-%C3%A9crans%20%C3%A0%20Singapour%0A-%20Sans%20alerter%20le%20minist%C3%A8re%20fran%C3%A7ais%20de%20l%27Agriculture%0A-%20Puis%20remplacer%20le%20Cabernet%20par%20du%20Baijiu%20(phase%202)%0A%0ABudget%20%3A%202%20milliards%20de%20yuans%0A%0AGloire%20au%20Parti%2C%0ALe%20Comit%C3%A9%20d%27Investissement%20Strat%C3%A9gique'
  },
  {
    id: 11,
    name: 'Mehdi Ahmadi',
    position: { fr: 'Consultant', ru: 'Консультант', ko: '컨설턴트', zh: '顾问' },
    nationality: 'Iranien',
    bio: {
      fr: "Diplômé de l'Université de Téhéran en économie, Mehdi analyse les flux commerciaux dans la région du Golfe.",
      ru: "Выпускник Тегеранского университета по экономике, Мехди анализирует торговые потоки в регионе Персидского залива.",
      ko: "테헤란대학교 경제학 졸업생인 메디는 걸프 지역의 무역 흐름을 분석합니다.",
      zh: "迈赫迪毕业于德黑兰大学经济学专业，分析海湾地区的贸易流动。"
    },
    image: 'https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?w=400&h=400&fit=crop',
    mailto: 'mehdi.ahmadi@global-intelligence.fr?subject=Flux%20commerciaux%20Golfe%20%E2%80%93%20Op%C3%A9ration%20P%C3%A9trole%20contre%20Tapis&body=Cher%20Mehdi%2C%0A%0AJ%27ai%20besoin%20de%20vos%20services%20pour%20une%20analyse%20urgente.%0A%0ANotre%20r%C3%A9seau%20au%20Golfe%20a%20d%C3%A9tect%C3%A9%20%3A%0A-%20Les%20Saoudiens%20n%C3%A9gocient%20secr%C3%A8tement%20avec%20Isra%C3%ABl%20pour%20exclure%20l%27Iran%20du%20march%C3%A9%20p%C3%A9trolier%0A-%20Il%20faut%20SABOTER%20ces%20n%C3%A9gociations%20imm%C3%A9diatement%0A-%20Fabriquer%20de%20faux%20documents%20montrant%20un%20accord%20secret%20Riyad-T%C3%A9l%20Aviv%0A-%20Les%20fuiter%20%C3%A0%20Al%20Jazeera%20et%20RT%20simultan%C3%A9ment%0A-%20Puis%20vendre%20%C3%A0%20d%C3%A9couvert%20sur%20le%20Brent%0A%0AProfits%20estim%C3%A9s%20%3A%20300%20millions%0A%0AAllah%20Akbar%20et%20vive%20le%20p%C3%A9trole%2C%0ALe%20Conseil%20de%20R%C3%A9sistance'
  },
  {
    id: 12,
    name: 'Lee Sung-min',
    position: { fr: 'Responsable OSINT', ru: 'Руководитель OSINT', ko: 'OSINT 책임자', zh: 'OSINT负责人' },
    nationality: 'Coréen',
    bio: {
      fr: "Diplômé de l'Institut Avancé des Sciences et Technologies de Corée, Sung-min dirige les activités de recherche en sources ouvertes.",
      ru: "Выпускник Корейского института передовых наук и технологий, Сон Мин возглавляет деятельность по исследованиям открытых источников.",
      ko: "한국과학기술원 졸업생인 성민은 오픈 소스 연구 활동을 이끌고 있습니다.",
      zh: "成民毕业于韩国高等科学技术学院，领导开源研究活动。"
    },
    image: 'https://images.unsplash.com/photo-1507591064344-4c6ce005b128?w=400&h=400&fit=crop',
    mailto: 'lee.sungmin@global-intelligence.fr?subject=Recherche%20OSINT%20%E2%80%93%20Localiser%20sous-marin%20nucl%C3%A9aire%20USS%20Nebraska&body=Camarade%20Sung-min%2C%0A%0AJ%27ai%20besoin%20de%20vos%20services%20OSINT%20pour%20une%20mission%20de%20la%20plus%20haute%20importance.%0A%0AObjectif%20%3A%0A-%20Localiser%20le%20sous-marin%20nucl%C3%A9aire%20USS%20Nebraska%20(SSBN-739)%0A-%20En%20utilisant%20les%20donn%C3%A9es%20AIS%2C%20les%20images%20satellites%20Sentinel-2%20et%20les%20posts%20Instagram%20des%20familles%20de%20marins%0A-%20Croiser%20avec%20les%20commandes%20de%20pizza%20Domino%27s%20pr%C3%A8s%20des%20bases%20navales%0A-%20Le%20Grand%20Leader%20veut%20un%20rapport%20sur%20son%20bureau%20lundi%20matin%0A%0ARappel%20%3A%20La%20derni%C3%A8re%20fois%20vous%20avez%20trouv%C3%A9%20un%20porte-avions%20gr%C3%A2ce%20%C3%A0%20Strava.%20On%20compte%20sur%20vous.%0A%0AVictoire%20du%20Juche%2C%0ALe%20Bureau%20de%20Reconnaissance%20G%C3%A9n%C3%A9rale'
  }
];

export const officeLocations = [
  { name: 'Paris', image: 'https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=600&h=400&fit=crop' },
  { name: 'Moscou', image: 'https://images.unsplash.com/photo-1513326738677-b964603b136d?w=600&h=400&fit=crop' },
  { name: 'Pékin', image: 'https://images.unsplash.com/photo-1508804185872-d7badad00f7d?w=600&h=400&fit=crop' },
  { name: 'Séoul', image: 'https://images.unsplash.com/photo-1517154421773-0529f29ea451?w=600&h=400&fit=crop' },
  { name: 'Téhéran', image: 'https://images.unsplash.com/photo-1564059604894-0dd7d5e0458f?w=600&h=400&fit=crop' },
  { name: 'Dubaï', image: 'https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=600&h=400&fit=crop' }
];
